import { useSelector } from 'react-redux'

import { SearchOnMap } from '@/components/SearchOnMap'
import { selectTerritoryCenter } from '@/features/domain/territory'
import { InspectPinMode, Map as MainMap, MapLayer } from '@/map'

interface Props {
  bottomContentPadding?: number
  disableAutoCenter?: boolean
}

export function Map(props: Props) {
  const { disableAutoCenter, bottomContentPadding } = props

  const territoryCenter = useSelector(selectTerritoryCenter)
  const center = disableAutoCenter ? undefined : territoryCenter

  return (
    <MainMap
      selectionContext="main"
      mapId="ww-map"
      center={center}
      bottomContentPadding={bottomContentPadding}
    >
      <InspectPinMode mode="normal" />

      <MapLayer uid="order" interactive />
      <MapLayer uid="place" interactive />
      <MapLayer uid="depot" interactive />
      <MapLayer uid="vehicle" interactive />
      <MapLayer uid="region" />
      <MapLayer uid="roadSegment" />
      <MapLayer uid="geofence" visible={false} />
      <MapLayer uid="routePolyline" />

      <MapLayer uid="breadcrumbPath" />
      <MapLayer uid="breadcrumbPoints" visible interactive />

      <SearchOnMap />
      {/* TODO: Add remaining layers once they are implemented */}
    </MainMap>
  )
}
